import { DateInput } from './DateInput';
import { MonthInput } from './MonthInput';
import { NumberInput } from './NumberInput';
import { ParsedNumberInput } from './ParsedNumberInput';
import { TextInput } from './TextInput';
import { YearInput } from './YearInput';

export * from './enums';

export const Input = {
  Text: TextInput,
  Number: NumberInput,
  Date: DateInput,
  Year: YearInput,
  Month: MonthInput,
  ParsedNumber: ParsedNumberInput
};
